import { useDispatch } from 'store/hooks';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import {
    bufferedPositionEntryClearAction,
    bufferedPositionEntrySetAction,
} from 'positionEntry/store/thunks';
import { PositionEntryInput } from './PositionEntryState';
import { positionEntryInputSetAction } from 'positionEntry/store/actions';

export const useDispatchPositionEntrySet = () => {
    const dispatch = useDispatch();
    return (position: PortfolioPosition) => {
        dispatch(bufferedPositionEntrySetAction(position));
    };
};

export const useDispatchPositionEntryInputSet = () => {
    const dispatch = useDispatch();
    return (input: PositionEntryInput) => {
        dispatch(positionEntryInputSetAction(input));
    };
};

export const useDispatchPositionEntryClear = () => {
    const dispatch = useDispatch();
    return (clearInput?: boolean) => {
        dispatch(bufferedPositionEntryClearAction(clearInput));
    };
};
